export default __webpack_public_path__ + "static/media/questionnaires_filled.28776cb8.jpg";